module.exports = __webpack_public_path__ + "static/media/cafe_03.af677f83.png";